import { createTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux"; 
import { ThemeProvider } from "@mui/material/styles";
import { getAllData } from "./service/Service";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0A543B",
    },
    secondary: {
      main: "#499178",
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: "#0a543b",
          color: "white",
        },
      },
    },
  },
});

function App() {
  // Redux State
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  
  // Local State
  const [fetch, setFetch] = useState(true);

  useEffect(()=> {
    if(fetch){
      getAllData(dispatch, token);
      setFetch(true);
    }
  }, [fetch])
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <AppRoutes />
      </ThemeProvider>
    </div>
  );
}

export default App;
